var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAzureAks(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.5,
    fill: "white",
    stroke: "#E0E0E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4015 13.0675L12.9131 14.0461V10L15.4015 10.8804V13.0675Z",
    fill: "#804998"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6827 10.6854V13.3282L12.5254 14.046V10.0321L10.6827 10.6854ZM10.8757 13.1319L10.7799 13.0996V10.914L10.8757 10.8803L10.9729 10.8481L11.0702 10.8158V13.1992L10.9729 13.1669L10.8757 13.1319ZM11.3618 13.2623L11.2312 13.2328V10.7822L11.3618 10.7499L11.4909 10.7177L11.62 10.6854V13.3604L11.4978 13.3282L11.3618 13.2623ZM11.9436 13.4585L11.7756 13.3941V10.6196L11.938 10.5873L12.0991 10.5214L12.2935 10.4569V13.5567L12.0991 13.4908L11.9436 13.4585Z",
    fill: "#804998"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1878 13.0675L18.6981 14.0461V10L21.1878 10.8804V13.0675Z",
    fill: "#804998"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4677 10.6854V13.3282L18.3104 14.046V10.0321L16.4677 10.6854ZM16.6621 13.1319L16.5649 13.0996V10.914L16.6621 10.8803L16.7593 10.8481L16.8565 10.8158V13.1992L16.7593 13.1669L16.6621 13.1319ZM17.1467 13.2623L17.0176 13.2328V10.7822L17.1467 10.7499L17.2759 10.7177L17.405 10.6854V13.3604L17.2759 13.3282L17.1467 13.2623ZM17.7285 13.4585L17.5675 13.3941V10.6196L17.7285 10.5873L17.8855 10.5214L18.0785 10.4569V13.5567L17.8855 13.4908L17.7285 13.4585Z",
    fill: "#804998"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4015 21.0953L12.9131 22.0738V18.0277L15.4015 18.9082V21.0953Z",
    fill: "#804998"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6827 18.7132V21.3559L12.5254 22.0737V18.0599L10.6827 18.7132ZM10.8757 21.1596L10.7799 21.1274V18.9417L10.8757 18.9081L10.9729 18.8758L11.0702 18.8436V21.2241L10.9729 21.1919L10.8757 21.1596ZM11.3618 21.2914L11.2312 21.2578V18.8113L11.3618 18.7777L11.4909 18.7454L11.62 18.7132V21.3881L11.4978 21.3559L11.3618 21.2914ZM11.9436 21.4863L11.7756 21.4218V18.6473L11.938 18.615L12.0991 18.5492L12.2935 18.4847V21.5844L12.0991 21.5199L11.9436 21.4863Z",
    fill: "#804998"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1878 21.0953L18.6981 22.0738V18.0277L21.1878 18.9082V21.0953Z",
    fill: "#804998"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4677 18.7132V21.3559L18.3104 22.0737V18.0599L16.4677 18.7132ZM16.6621 21.1596L16.5649 21.1274V18.9417L16.6621 18.9081L16.7593 18.8758L16.8565 18.8436V21.2241L16.7593 21.1919L16.6621 21.1596ZM17.1467 21.2914L17.0176 21.2578V18.8113L17.1467 18.7777L17.2759 18.7454L17.405 18.7132V21.3881L17.2759 21.3559L17.1467 21.2914ZM17.7285 21.4863L17.5675 21.4218V18.6473L17.7285 18.615L17.8855 18.5492L18.0785 18.4847V21.5844L17.8855 21.5199L17.7285 21.4863Z",
    fill: "#804998"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4714 17.0814L16.015 18.0277V14.0139L18.4714 14.8943V17.0814Z",
    fill: "#804998"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7532 14.6658V17.3099L15.5959 18.0277V14.0139L13.7532 14.6658ZM13.9476 17.1136L13.8504 17.0814V14.8943L13.9476 14.8621L14.0448 14.8298L14.1406 14.7962V17.1795L14.0448 17.1459L13.9476 17.1136ZM14.4322 17.2777L14.3031 17.244V14.7962L14.4322 14.7639L14.5614 14.7317L14.6905 14.6994V17.3744L14.5614 17.3421L14.4322 17.2777ZM15.0141 17.4725L14.8516 17.408V14.6349L15.0141 14.6027L15.1751 14.5368L15.3695 14.4723V17.5707L15.1751 17.5048L15.0141 17.4725Z",
    fill: "#804998"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7186 17.0814L10.2621 18.0277V14.0139L12.7186 14.8943V17.0814Z",
    fill: "#804998"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14.6658V17.3099L9.8427 18.0277V14.0139L8 14.6658ZM8.19302 17.1136L8.0972 17.0814V14.8943L8.19302 14.8621L8.29022 14.8298L8.38742 14.7962V17.1795L8.29022 17.1459L8.19302 17.1136ZM8.67903 17.2777L8.5485 17.244V14.7962L8.67903 14.7639L8.80818 14.7317L8.93732 14.6994V17.3744L8.80818 17.3421L8.67903 17.2777ZM9.26087 17.4725L9.0984 17.408V14.6349L9.26087 14.6027L9.42194 14.5368L9.61635 14.4723V17.5707L9.42194 17.5048L9.26087 17.4725Z",
    fill: "#804998"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1607 17.0814L21.7043 18.0277V14.0139L24.1607 14.8943V17.0814Z",
    fill: "#804998"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M15.4015 13.0675L12.9131 14.0461V10L15.4015 10.8804V13.0675Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M21.1878 13.0675L18.6981 14.0461V10L21.1878 10.8804V13.0675Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M15.4015 21.0953L12.9131 22.0738V18.0277L15.4015 18.9082V21.0953Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M21.1878 21.0953L18.6981 22.0738V18.0277L21.1878 18.9082V21.0953Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M18.4714 17.0814L16.015 18.0277V14.0139L18.4714 14.8943V17.0814Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M12.7186 17.0814L10.2621 18.0277V14.0139L12.7186 14.8943V17.0814Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M24.1607 17.0814L21.7043 18.0277V14.0139L24.1607 14.8943V17.0814Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4421 14.6658V17.3099L21.2848 18.0277V14.0139L19.4421 14.6658ZM19.6351 17.1136L19.5393 17.0814V14.8943L19.6351 14.8621L19.7323 14.8298L19.8295 14.7962V17.1795L19.7323 17.1459L19.6351 17.1136ZM20.1212 17.2777L19.992 17.244V14.7962L20.1212 14.7639L20.2503 14.7317L20.3794 14.6994V17.3744L20.2503 17.3421L20.1212 17.2777ZM20.703 17.4725L20.5405 17.408V14.6349L20.703 14.6027L20.8641 14.5368L21.0585 14.4723V17.5707L20.8641 17.5048L20.703 17.4725Z",
    fill: "#804998"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzureAks);
export default __webpack_public_path__ + "static/media/azure-aks.97186691ae3d74268dc763f152c1e8e4.svg";
export { ForwardRef as ReactComponent };